import { createContext } from "react";

const CalendarEventContext = createContext();

export default CalendarEventContext;